/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Research_LabelInputs */

const en_cap_research_label = /** @type {(inputs: Cap_Research_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Research`)
};

const lv_cap_research_label = /** @type {(inputs: Cap_Research_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Izpēte`)
};

/**
* | output |
* | --- |
* | "Research" |
*
* @param {Cap_Research_LabelInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_research_label = /** @type {((inputs?: Cap_Research_LabelInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Research_LabelInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_research_label(inputs)
	return en_cap_research_label(inputs)
});